import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withTranslate } from 'react-redux-multilingual'

class NavBar extends Component {
    constructor(props) {
        super(props);
        let loggedIn = true
        let EmailID=null
        let RoleName=null
        let UserName=null
        let parsedLoginData = localStorage.getItem('loginObject')
        parsedLoginData = JSON.parse(parsedLoginData);
        // console.log(parsedLoginData);
         if(parsedLoginData!==null){
            EmailID=parsedLoginData.EmailID;
            RoleName=parsedLoginData.RoleName;
            UserName=parsedLoginData.UserName;
          }
          else{
            loggedIn = false;
          }

        this.state = {
            navClose: { right: '0px' },
            loggedIn,
            RoleName,
            EmailID,
            UserName,
        }
    }

    componentWillMount() {
        if (window.innerWidth < 750) {
            this.setState({ navClose: { right: '-410px' } })
        }
        if (window.innerWidth < 1199) {
            this.setState({ navClose: { right: '-300px' } })
        }
    }

    openNav() {
       // console.log('open')
        this.setState({ navClose: { right: '0px' } })
    }
    closeNav() {
        this.setState({ navClose: { right: '-410px' } })
    }

    onMouseEnterHandler() {
        if (window.innerWidth > 1199) {
            document.querySelector("#main-menu").classList.add("hover-unset");
        }
    }

    handleSubmenu = (event) => {
        if (event.target.classList.contains('sub-arrow'))
            return;

        if (event.target.nextElementSibling.classList.contains('opensubmenu'))
            event.target.nextElementSibling.classList.remove('opensubmenu')
        else {
            document.querySelectorAll('.nav-submenu').forEach(function (value) {
                value.classList.remove('opensubmenu');
            });
            document.querySelector('.mega-menu-container').classList.remove('opensubmenu')
            event.target.nextElementSibling.classList.add('opensubmenu')
        }
    }

    handleMegaSubmenu = (event) => {
        if (event.target.classList.contains('sub-arrow'))
            return;

        if (event.target.parentNode.nextElementSibling.classList.contains('opensubmegamenu'))
            event.target.parentNode.nextElementSibling.classList.remove('opensubmegamenu')
        else {
            document.querySelectorAll('.menu-content').forEach(function (value) {
                value.classList.remove('opensubmegamenu');
            });
            event.target.parentNode.nextElementSibling.classList.add('opensubmegamenu')
        }
    }

    render() {


        const { translate } = this.props;
        let menuUser;
        if(this.state.loggedIn===true){
        if(this.state.RoleName=="Patient"){
           menuUser= 
           <ul className="nav-menu" style={this.state.navClose}>  
           <li className="back-btn" onClick={this.closeNav.bind(this)} >
                   <div className="mobile-back text-right">
                       <span >Back</span>
                       <i className="fa fa-angle-right pl-2" aria-hidden="true"></i>
                   </div>
               </li>
			   <li><Link to={`${process.env.PUBLIC_URL}/pre-registration`} className="nav-link" onClick={(e) => this.handleSubmenu(e)}>
           Pre-registration for COVID-19 Testing
        </Link>
        </li> 
           
           <li>
           <Link to="#" className="nav-link" onClick={(e) => this.handleSubmenu(e)}>
               Hello, {this.state.UserName}
               <span className="sub-arrow"></span>
           </Link>
           <ul className="nav-submenu">
               {/* <li><Link to={`${process.env.PUBLIC_URL}/patient`} >Patient</Link></li> */}
               {/* <li><Link to={`${process.env.PUBLIC_URL}/patient-checkout`} >checkout</Link></li> */}
               <li><Link to={`${process.env.PUBLIC_URL}/patient-dashboard`} >Dashboard</Link></li>
               <li><Link to={`${process.env.PUBLIC_URL}/pending-orders`} >Pending Order</Link></li>
               {/* <li><Link to={`${process.env.PUBLIC_URL}/order-summary`} >Order Summary</Link></li> */}
               <li><Link to={`${process.env.PUBLIC_URL}/patient-order`} >Order</Link></li>
               <li><Link to={`${process.env.PUBLIC_URL}/pages/logout`} >{translate('logout')}</Link></li>
               
           </ul>
       </li>
       <li className="mega-menu">
                                <div className="mega-menu-container" >                                  
                                </div>
                            </li>
                        
                        
                        </ul>

      }
     else if(this.state.RoleName=="Provider"){
        menuUser= 
        <ul className="nav-menu" style={this.state.navClose}>  
        <li className="back-btn" onClick={this.closeNav.bind(this)} >
                <div className="mobile-back text-right">
                    <span >Back</span>
                    <i className="fa fa-angle-right pl-2" aria-hidden="true"></i>
                </div>
            </li>
        <li>
        <Link to="#" className="nav-link" onClick={(e) => this.handleSubmenu(e)}>
        Hello, {this.state.UserName}
            <span className="sub-arrow"></span>
        </Link>
        <ul className="nav-submenu">
            <li><Link to={`${process.env.PUBLIC_URL}/provider`} >Place Order</Link></li>
            <li><Link to={`${process.env.PUBLIC_URL}/provider-dashboard`} >Dashboard</Link></li>
            <li><Link to={`${process.env.PUBLIC_URL}/provider-order`} >Order</Link></li>
            <li><Link to={`${process.env.PUBLIC_URL}/pages/logout`} >{translate('logout')}</Link></li>
        </ul>
         </li>

         <li className="mega-menu">
                                <div className="mega-menu-container" >                                  
                                </div>
                            </li>
                        
                        
                        </ul>
      }
      else{
        menuUser=
<ul className="nav-menu" style={this.state.navClose}>  
        <li className="back-btn" onClick={this.closeNav.bind(this)} >
                <div className="mobile-back text-right">
                    <span >Back</span>
                    <i className="fa fa-angle-right pl-2" aria-hidden="true"></i>
                </div>
            </li>
        <li><Link to={`${process.env.PUBLIC_URL}/pre-registration`} className="nav-link" onClick={(e) => this.handleSubmenu(e)}>
           Pre-registration for COVID-19 Testing
        </Link>
        </li> 
        <li>
        <Link to={`${process.env.PUBLIC_URL}/pages/login`} className="nav-link" onClick={(e) => this.handleSubmenu(e)}>
            Login
           
        </Link>
        </li>
        <li className="mega-menu">
                                <div className="mega-menu-container" >                                  
                                </div>
                            </li>
                        
                        
                        </ul>
    }
      
    }
    else{
        menuUser= 
<ul className="nav-menu" style={this.state.navClose}>  
        <li className="back-btn" onClick={this.closeNav.bind(this)} >
                <div className="mobile-back text-right">
                    <span >Back</span>
                    <i className="fa fa-angle-right pl-2" aria-hidden="true"></i>
                </div>
            </li>
            <li><Link to={`${process.env.PUBLIC_URL}/pre-registration`} className="nav-link" onClick={(e) => this.handleSubmenu(e)}>
           Pre-registration for COVID-19 Testing
        </Link>
        </li> 
        <li >
        <Link to={`${process.env.PUBLIC_URL}/pages/login`} className="nav-link" onClick={(e) => this.handleSubmenu(e)}>
            Login
          
        </Link>
       
        </li>
    
    <li className="mega-menu">
    <div className="mega-menu-container" >                                  
    </div>
</li>


</ul>
}
        return (
            <div>
                <div className="main-navbar">
                    <div id="mainnav" >
                        <div className="toggle-nav" onClick={this.openNav.bind(this)} >
                            <i className="fa fa-bars sidebar-bar"></i>
                        </div>
                        
                        
                        
                        {menuUser}
                       
                       
                       
                    </div>
                </div>
            </div>
        )
    }
}


export default withTranslate(NavBar);